import { render, staticRenderFns } from "./SendInformationWidget.vue?vue&type=template&id=01615521&scoped=true&"
import script from "./SendInformationWidget.vue?vue&type=script&lang=js&"
export * from "./SendInformationWidget.vue?vue&type=script&lang=js&"
import style0 from "./SendInformationWidget.vue?vue&type=style&index=0&id=01615521&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01615521",
  null
  
)

export default component.exports